import { render, staticRenderFns } from "./QueryHistory.vue?vue&type=template&id=bb1f0534&scoped=true"
import script from "./QueryHistory.vue?vue&type=script&lang=js"
export * from "./QueryHistory.vue?vue&type=script&lang=js"
import style0 from "./QueryHistory.vue?vue&type=style&index=0&id=bb1f0534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f0534",
  null
  
)

export default component.exports